import { EXCEPTIONS_WRONG_LANG as PREFIX } from "const";
import {
    EXCEPTIONS_WRONG_LANG_SET_LOADING,
    EXCEPTIONS_WRONG_LANG_SET_LIST
} from "actions/actionTypes";

const initialState = {
    list: [],
    loading: true
};

const handlers = {
    [EXCEPTIONS_WRONG_LANG_SET_LOADING]: (state, {payload}) => ({...state, loading: payload}),
    [EXCEPTIONS_WRONG_LANG_SET_LIST]: (state, {payload: {list}}) => {
        return {
            ...state,
            list: list,
            loading: false
        }
    },
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};